export const WIZARD = {
  PAGES: {
    winningTeam: 0,
    topScorer: 1,
    games: 2,
  }
}